<script setup>
import {
  ref,
  defineProps,
  watchEffect,
  defineExpose,
  computed,
  provide,
  defineEmits,
} from 'vue';
import { getTable } from 'src/utils/common';
import { getAddToCart, getCartItemData } from 'src/api/cart.js';
import { getProductDetails } from 'src/api/details';
import _ from 'lodash';
import { expandArr } from 'src/utils/loadsh';
import MyDialog from 'src/components/dialog/index.vue';
import RecommendProduct from 'src/components/recommend/RecommendProduct';
import { scroll } from 'quasar';
import { getConfig } from 'src/utils/error_config.js';
import { reqAddToCart } from 'src/api/fullDineIn';
import { useErrorDialog } from 'src/pages/details/error_config';
import {
  BasicInfo,
  Modifiler,
  Bundling,
  Products,
  Comment,
  Footer,
} from '../pages/details/components/index';
import { verify } from '../pages/details/components/units';
import { useIns, useStore } from '../utils/v2_helper/common';
import { useRoute, useRouter } from '../utils/v2_helper/router';
import { useRequest } from '../utils/hooks/use-requset';
import {
  ADD_SUCCESS_RECOMMEND,
  PRODUCT_DETAIL_INVALID,
  RECOMMEND_PRODUCT_INVALID,
} from '../utils/config';
import { getCartTableId } from '../utils/common';

const { show: showErrorDialog } = useErrorDialog();
const emit = defineEmits(['back']);
const props = defineProps({
  productId: {
    type: String,
    default: '',
  },
  tag: {
    type: String,
    default: '',
  },
  historyData: {
    type: String,
    default: '',
  },
});
const bundlingRef = ref();
const productsRef = ref();
const app = useIns();
const router = useRouter();
const route = useRoute();
const store = useStore();

const _productId = computed(() => route.query.id || props.productId);
const _tag = computed(() => route.query.tag || props.tag);
const _historyData = computed(
  () => route.query.historyData || props.historyData,
);

const {
  data: productData,
  loading: fetching,
  error: fetchError,
  run,
} = useRequest(getProductDetails, {
  params: _productId.value,
  after: (res) => res.data,
});

const visible = ref(false);
const newModifier = ref([]);
const loading = ref(false);
const max = ref(999); // 允许最大加购数量
const stock = ref(0); // 库存
const cartCount = ref({}); // 加购数据
// 产品库存
const inStock = ref(false);
// 备注
const comment = ref('');
// 单独商品 modifiers
// modifiers 返回参数
const optParams = ref([]);
const modifiers = ref([]);
const showModifiers = ref(false);
// 组合商品 baseGroup
// baseParams 返回参数
const baseParams = ref({});
const baseGroup = ref({});
const showBaseGroup = ref(false);
// 组合商品 optionGroups
// optionParams 返回参数
const optionParams = ref([]);
const optionGroups = ref([]);
const showOptionGroups = ref(false);
const stockPool = ref([]);

// computed
const isRecommend = computed(() => _tag.value?.indexOf('recommend') >= 0);

function onBack() {
  visible.value = false;
  emit('back');
}
// 滚动到指定元素
function scrollToElement(el) {
  el?.scrollIntoView();
}
// 前端验证
async function verifyModifier() {
  const isPass = [];
  // 基础产品modifiers验证
  if (showModifiers.value) {
    const result = verify(modifiers.value, optParams.value, (name, min, id) => {
      const errDom = document.querySelector(`#a${id}`);
      console.log('ERR_DOM:', errDom);
      if (errDom) scrollToElement(errDom);
      app.$q.notify({
        message: app.$t('details.verifyRequired', { name, min }),
        spinner: false,
        position: 'bottom',
        classes: 'glossy',
        type: 'ongoing',
        timeout: 1500,
      });
    });
    isPass.push(result);
  }
  // 基础套餐modifiers验证
  if (showBaseGroup.value) {
    const baseResult = bundlingRef.value?.checkRequired();
    const baseIsPass = baseResult.every((item) => item);
    isPass.push(baseIsPass);
  }
  // 套餐可选商品验证
  if (showOptionGroups.value) {
    // 套餐可选商品modifiers验证
    const optiResult = productsRef.value?.checkRequired();
    const optiIsPass = optiResult.every((group) => group.every((it) => it));
    isPass.push(optiIsPass);
    // 套餐可选组个数验证
    const numResult = productsRef.value?.checkSelectNum();
    const numIsPass = numResult.every((item) => item);
    isPass.push(numIsPass);
  }
  return isPass.every((item) => item);
}
async function requestAddApi(params) {
  const callApi = app.isFullDineIn ? reqAddToCart : getAddToCart;
  if (app.isFullDineIn) {
    const { tableId, cartId } = getCartTableId();
    params.tableId = tableId;
    params.cartId = cartId;
    params.tableNumber = getTable();
  } else {
    params = { addItem: { ...params } };
  }
  try {
    const res = await callApi(params);
    loading.value = false;
    const { code, data } = res;
    if (code === 200) {
      if (isRecommend.value) app.$bus.$emit(ADD_SUCCESS_RECOMMEND);
      onBack();
    } else {
      // 当状态码为517(TABLE_CHANGED)的时候data为桌号
      showErrorDialog(code, { table: data, product: productData.value });
    }
  } catch (error) {
    console.log(error);
    loading.value = false;
  }
}
async function addToCart(quantity) {
  if (loading.value) return;
  loading.value = true;
  // 前端校验
  const verifyResult = await verifyModifier();
  if (!verifyResult) {
    loading.value = false;
    const errDom = document.querySelector('.errorTips');
    if (errDom) scrollToElement(errDom);
    return false;
  }
  // 区分普通商品和套餐
  const { productType: types } = productData.value;
  const type = types === 'GOOD' ? 'single' : 'package';
  const params = expandArr(optParams.value);
  const cartParams = {
    type,
    productId: _productId.value,
    quantity,
    modifiers: params || [],
    baseGroup: baseParams.value || {},
    optionGroups: optionParams.value || [],
    comment: comment.value ? comment.value.slice(0, 20) : '',
    priceStamp: productData.value.listPrice,
  };
  requestAddApi(cartParams);
}

function init() {
  // 产品已下架 返回列表页
  if (productData.value) {
    const {
      inList: _inList,
      inLive: _inLive,
      inStock: _inStock,
      inService: _inService,
      inSingleSale: _inSingleSale,
    } = productData.value;
    if (!_inList || !_inStock || !_inLive || !_inService || !_inSingleSale) {
      // 通知推荐位产品刷新
      app.$bus.$emit(PRODUCT_DETAIL_INVALID, productData.value);
      app.$bus.$emit(RECOMMEND_PRODUCT_INVALID);
      app.$q
        .dialog({
          component: MyDialog,
          parent: app,
          title: app.$t('details.invalidTip'),
          ok: 'OK',
        })
        .onOk(() => {
          // 产品失效，通知刷新
          app.$bus.$emit(ADD_SUCCESS_RECOMMEND);
          if (isRecommend.value) {
            onBack();
          } else {
            router.replace({ name: 'products-list' });
          }
        });
      return false;
    }
  }
  if (!productData.value) return;
  const stockArr = [];
  const newData = _.cloneDeep(productData.value);
  const {
    modifiers: _modifiers = [],
    baseGroup: _baseGroup = {},
    optionGroups: _optionGroups = [],
  } = newData;
  inStock.value = newData.inStock;
  // 是否存在最大库存
  if (newData.productStock !== -1) {
    // 库存减去购物车数量，才是允许加购的最大库存
    const cartNumber = cartCount.value[newData.id] || 0
    max.value = newData.productStock - cartNumber;
    stock.value = newData.productStock;
  }
  // 单独商品 有 modifiers
  showModifiers.value = !_.isEmpty(_modifiers);
  if (showModifiers.value) modifiers.value = _modifiers;
  // 组合商品 有 baseGroup
  showBaseGroup.value = !_.isEmpty(_baseGroup);
  if (showBaseGroup.value) {
    baseGroup.value = _baseGroup;
    baseGroup.value?.members?.forEach((item) => {
      stockArr.push({
        id: item.product.id,
        stock: item.product.productStock,
      });
    });
  }
  // 可选商品 有 optionGroups
  showOptionGroups.value = !_.isEmpty(optionGroups);
  if (showOptionGroups.value) {
    optionGroups.value = _optionGroups;
    optionGroups.value?.forEach((group) => {
      group.members?.forEach((item) => {
        stockArr.push({
          id: item.product.id,
          stock: item.product.productStock,
        });
      });
    });
  }
  // 去重 得出最终套餐内商品库存池
  stockPool.value = _.uniqWith(stockArr, _.isEqual);
}

function resetData() {
  productData.value = null;
  comment.value = '';
}

watchEffect(() => {
  if (visible.value && _productId.value) {
    // run(_productId.value).then(() => init());
    run(_productId.value).then(async () => {
      // 获取购物车数量
      const res = await getCartItemData()
      cartCount.value = res.data
      init()
    });
  } else {
    resetData();
  }
});
defineExpose({
  visible,
});
provide('isRecommend', isRecommend);
</script>

<template>
  <q-dialog
    v-model="visible"
    maximized
    transition-show="xx"
    transition-hide="xx"
  >
    <div class="detail theme-bg-gray">
      <div class="pc-width-pull-full header">
        <div class="icon">
          <i class="iconfont dm-arrow-left" @click="onBack" />
        </div>
      </div>
      <p v-if="fetching">&nbsp;</p>
      <BaseError v-if="fetchError" />
      <template v-if="productData && !fetchError">
        <BasicInfo :info="productData" />
        <RecommendProduct v-if="!isRecommend" class="recommendation">
          <div class="recommendation-tile">
            {{ $t('common.recommendation') }}
          </div>
        </RecommendProduct>
        <Modifiler
          v-if="showModifiers"
          v-model="optParams"
          :original="modifiers"
          :history-data="_historyData"
        />
        <Bundling
          v-if="showBaseGroup"
          ref="bundlingRef"
          v-model="baseParams"
          :original="baseGroup"
        />
        <Products
          v-if="showOptionGroups"
          ref="productsRef"
          v-model="optionParams"
          :original="optionGroups"
        />
        <Comment v-model="comment" />
        <div style="height: 120px" />
        <Footer
          :in-stock="inStock"
          :max="max"
          :stock="stock"
          :loading="loading"
          @add="addToCart"
        />
      </template>
    </div>
  </q-dialog>
</template>

<style lang="scss" scoped>
.detail {
  height: 100%;
  overflow: auto;
  .header {
    position: fixed;
    top: 10px;
    z-index: 2;
    .icon {
      background: #fff;
      height: 40px;
      width: 40px;
      border-radius: 8px;
      margin-left: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .iconfont {
      font-size: 24px;
    }
  }
  .recommendation {
    background: #fff;
    padding-bottom: 24px;
    padding-top: 0;
    border-top: none;
    &-tile {
      margin-bottom: 8px;
      font-weight: bold;
    }
  }
}
</style>
